import {
    ajax
} from '@/utils/request'

// 定位树
export function locationList() {
    return ajax('api/v1/sysLocation/group')
}